import $ from '../vendor/jquery';

$(function() {
  $('.counter').counterUp({
    delay: 10,
    time: 1000
  });
});



// WEBPACK FOOTER //
// ./public/assets/js/src/components/counters.js